module.exports = __webpack_public_path__ + "static/media/chevron-down.a808bfd2.svg";